module.exports = __webpack_public_path__ + "static/media/profileEmoji.9797e39e.png";